module.exports = __webpack_public_path__ + "img/cooperation22.7c7893c9.png";